import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { AuthAction } from '../../store/actions';

class ResetPassword extends PureComponent {
  static propTypes = {
    resetPassword: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location.search);
    this.state = {
      email: params.get('email'),
      password: '',
      password_confirmation: '',
      token: params.get('token'),
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.resetPassword(this.state);
  }

  render() {
    return (
      <div className="hold-transition login-page">
        <div className="login-box">
          <div className="card card-outline card-primary">
            <div className="card-header text-center">
              <b className="h1">Reset Password</b>
            </div>
            <div className="card-body">
              <form onSubmit={this.onSubmit.bind(this)}>
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    name="password"
                    onChange={this.onChange}
                    placeholder="Password"
                    type="password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    name="password_confirmation"
                    onChange={this.onChange}
                    placeholder="Confirm Password"
                    type="password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <button className="btn btn-block btn-primary" type="submit">
                      Reset
                    </button>
                  </div>
                  <div className="col-6 text-right">
                    <Link to="/login">Sign In!</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  resetPassword: data => dispatch(AuthAction.resetPassword(data)),
});

export default connect(null, mapDispatchToProps)(ResetPassword);
